import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        userData:null, //用户数据
        userId:null, //用户ID
    },
    actions:{
        setUserData({commit,state},name){
            commit("setUserData", name);
        },
        setUserId({commit,state},name){
            commit("setUserId", name);
        }
    },
    mutations:{
        setUserData(state,name){
            state.userData = name
        },
        setUserId(state,name){
            state.userId = name
        }
    },
    getters:{
        getUserData(state){
            return state.userData
        },
        getUserId(state){
            return state.userId
        }
    }
})




// WEBPACK FOOTER //
// ./src/store/index.js